import { render, staticRenderFns } from "./InformativesForm.vue?vue&type=template&id=6f237eff&scoped=true&"
import script from "./InformativesForm.vue?vue&type=script&lang=js&"
export * from "./InformativesForm.vue?vue&type=script&lang=js&"
import style0 from "./InformativesForm.vue?vue&type=style&index=0&id=6f237eff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f237eff",
  null
  
)

export default component.exports